module.exports = __webpack_public_path__ + "img/diacre.d2463f4b.jpg";